import React from 'react';
import { journeySteps } from '../data/sushiContent';
type JourneyStripProps = {
  className?: string;
};
export function JourneyStrip({
  className = ''
}: JourneyStripProps) {
  return <ol className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-2 sm:gap-x-4 ${className}`} aria-label="Los siete formatos de sushi del sistema" data-id="element-187" data-mp="2ysmiaw87bhgr">
      {journeySteps.map((step, i) => <li key={step} className="flex items-center gap-3 sm:gap-4" data-id="element-188" data-mp="263fb78uoljjw" data-mpi={i}>
          <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-ivory-200 sm:text-[11px]" data-id="element-189" data-mp="21541qz8atb27">
            <span className="mr-1.5 font-sans text-champagne" data-id="element-190" data-mp="2f4n4tdm95w7n">{i + 1}</span>
            {step}
          </span>
          {i < journeySteps.length - 1 && <span className="text-champagne/40" aria-hidden="true" data-id="element-191" data-mp="2b20bf89xo38c">
              →
            </span>}
        </li>)}
    </ol>;
}